import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Link, Outlet, useNavigate } from "react-router-dom"
import {
  AppBar,
  Toolbar,
  Button,
  List,
  ListItem,
  IconButton,
  Container,
  Box,
  styled,
} from "@mui/material"
import { makeStyles } from "@mui/styles"
import MenuIcon from "@mui/icons-material/Menu"
import CloseIcon from "@mui/icons-material/Close"

import { AsideComponent as Aside } from "components/ui/Aside"
import CookieConsent from "components/Layout/CookieConsent"
import LanguageSwitcher from "components/Layout/LanguageSwitcher"
import MobileTopList from "components/Layout/MobileTopList"
import Logo from "components/Layout/Logo"
import Notice from "components/Layout/Notice"
import Footer from "components/Layout/Footer"
import Tracker from "components/Layout/Tracker"
import Settings from "components/Layout/Settings"
// import Tawk from "components/Layout/Tawk"
import { useAppDispatch } from "redux/hooks"
import { reset as resetPolling } from "redux/features/polling/pollingSlice"

const PublicLayout = () => {
  const dispatch = useAppDispatch()
  const classes = useStyles()
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    handleResetPoling()
    setMobileOpen(!mobileOpen)
  }

  const handleLogin = () => {
    handleResetPoling()
    handleDrawerToggle()
    navigate("/login")
  }

  const handleResetPoling = () => {
    dispatch(resetPolling())
  }

  return (
    <>
      <Settings />
      <Notice />
      <Header elevation={0} color="transparent" position="static">
        <NavBar>
          <Link onClick={handleResetPoling} to="/login">
            <Logo white={false} />
          </Link>
          <Box>
            <LanguageSwitcher signedIn={false} />
            <NavButton color="primary" edge="end" onClick={handleDrawerToggle}>
              <MenuIcon />
            </NavButton>
          </Box>
        </NavBar>
      </Header>

      <Nav component="nav">
        <Aside
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{
            paper: classes.drawerPaper,
          }}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <NavBar>
            <Logo white />
            <NavButton color="primary" edge="end" onClick={handleDrawerToggle}>
              <CloseIcon />
            </NavButton>
          </NavBar>
          <MobileTopList signedIn={false} onClick={handleDrawerToggle} />
          <BottomList>
            <ListItem>
              <ListItemButton onClick={handleLogin}>
                {t("menu.login")}
              </ListItemButton>
            </ListItem>
          </BottomList>
        </Aside>
      </Nav>

      <Main component="main">
        <Container>
          <Outlet />
          <Footer />
        </Container>
      </Main>

      <CookieConsent />
      <Tracker />
      {/* <Tawk /> */}
    </>
  )
}

export default PublicLayout

const Header = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer - 1,
  [theme.breakpoints.up("lg")]: {
    padding: "42px",
  },
  [theme.breakpoints.down("lg")]: {
    padding: "6px",
  },
}))

const Main = styled(Box)(() => ({
  flexGrow: 1,
}))

const Nav = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("lg")]: {
    display: "none",
  },
}))

const NavButton = styled(IconButton)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    display: "none !important",
  },
}))

const NavBar = styled(Toolbar)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const BottomList = styled(List)`
  display: flex;
  flex-grow: 1;
  align-items: flex-end;
`

const ListItemButton = styled(Button)`
  background: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.common.white};
  border-radius: 28px;
  display: flex;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 17px;
  padding: 16px 14px;
  text-transform: initial;
  width: 100%;
`

const useStyles = makeStyles(() => ({
  drawerPaper: {
    width: "100%",
  },
}))
